import React, {FC, ReactNode} from "react";
import {Divider} from "../../Divider/Divider";
import classNames from "classnames";

type FourthStepInfoContainerProps = {
  title?: ReactNode;
  noDivider?: boolean;
  className?: string;
};

export const FourthStepInfoContainer: FC<FourthStepInfoContainerProps> = ({
  children,
  title,
  noDivider,
  className
}) => {
  return (
    <section className={classNames("FourthStepInfoContainer", className)}>
      <div className="FourthStepInfoContainer__content">
        {title && <h2 className="FourthStepInfoContainer__title">{title}</h2>}
        {children}
      </div>

      {!noDivider && 
        <Divider size='bold'/>
      }
    </section>
  );
};
